import { useAuthContext } from '../../context/AuthContext';
import HeroSection from '../../components/ui/HeroSection';
import ModuleCard from '../../components/ui/ModuleCard';
import { HOME_CARDS } from './homeCards';

const HomePage = () => {
  const auth = useAuthContext();
  const user = auth.user;

  const title = `Benvenuto${user?.profile?.given_name ? `, ${user.profile.given_name}` : ''}`;

  return (
    <div className="flex flex-col bg-gray-50">
      <HeroSection
        title={title}
        description="Accedi ai tuoi report, esplora i dati delle banche e gestisci le fonti."
      />

      <div className="flex-1 px-8 lg:px-16 py-12 w-full">
        <h2 className="text-2xl font-bold mb-2 font-heading" style={{ color: '#1B365D' }}>
          I tuoi strumenti
        </h2>
        <p className="text-gray-500 mb-8 font-paragraph">
          Seleziona il modulo a cui vuoi accedere.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {HOME_CARDS.map((card, i) => (
            <ModuleCard key={i} {...card} index={i} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
